// Ambang kuantil kecepatan buat mewarnai trail.

export const SPEED_COLORS = ['#1D4ED8', '#0EA5E9', '#10B981', '#F59E0B', '#EF4444'];

function sortedSpeeds(speeds) {
  return (speeds || [])
    .map(Number)
    .filter((v) => Number.isFinite(v))
    .sort((a, b) => a - b);
}

// Ambang kembar dan ambang yang nempel di nilai terkecil dibuang: dua-duanya
// bikin bucket yang gak pernah keisi, jadi warnanya kepakai buat rentang yang
// salah. Kapal idle punya banyak titik nol persis, jadi ini sering kejadian.
export function speedBuckets(speeds, count = SPEED_COLORS.length) {
  const cleaned = sortedSpeeds(speeds);
  if (cleaned.length === 0) return [];
  const min = cleaned[0];
  const raw = [];
  for (let i = 1; i < count; i += 1) {
    raw.push(cleaned[Math.floor((cleaned.length * i) / count)]);
  }
  return raw.filter((v, i) => v > min && raw.indexOf(v) === i);
}

// Warna tiap bucket, disebar merata di palet biar ujungnya tetap biru dan
// merah walau bucketnya tinggal sedikit. Satu bucket = gak ada variasi buat
// dibandingin, jadi ambil warna tengah ketimbang ngaku pelan atau ngebut.
export function bucketColors(thresholds) {
  const count = (thresholds || []).length + 1;
  const last = SPEED_COLORS.length - 1;
  if (count === 1) return [SPEED_COLORS[Math.floor(last / 2)]];
  return Array.from({ length: count }, (_, i) => SPEED_COLORS[Math.round((i * last) / (count - 1))]);
}

// Batas penuh tiap bucket: [terkecil, ...ambang, terbesar].
export function speedBounds(speeds, count = SPEED_COLORS.length) {
  const cleaned = sortedSpeeds(speeds);
  if (cleaned.length === 0) return [];
  return [cleaned[0], ...speedBuckets(cleaned, count), cleaned[cleaned.length - 1]];
}

// Satu presisi buat semua label: kapal lambat butuh dua angka, dan ditambah
// terus sampai tiap batas kebaca beda. Dihitung sekali dari seluruh deret,
// bukan per bucket, biar batas yang dipakai berdua ditulis sama.
function labelDecimals(bounds) {
  const bentrok = (d) => bounds.some((v, i) => i > 0
    && Number(v).toFixed(d) === Number(bounds[i - 1]).toFixed(d));
  let decimals = Math.abs(bounds[bounds.length - 1]) < 10 ? 2 : 1;
  while (decimals < 4 && bentrok(decimals)) decimals += 1;
  return decimals;
}

// Label rentang satu bucket. Batas dan keluaran pakai satuan yang sama.
export function bucketLabel(i, bounds) {
  if (!Array.isArray(bounds) || bounds.length < 2) return null;
  const j = Math.min(Math.max(i, 0), bounds.length - 2);
  const decimals = labelDecimals(bounds);
  const f = (v) => Number(v).toFixed(decimals);
  return `${f(bounds[j])} – ${f(bounds[j + 1])}`;
}

export function bucketOf(speed, thresholds) {
  const v = Number(speed);
  if (!Number.isFinite(v) || !thresholds || thresholds.length === 0) return 0;
  let i = 0;
  while (i < thresholds.length && v >= thresholds[i]) i += 1;
  return i;
}
